import CryptoIcon from "components/Secondary/CryptoIcon";
import { useEffect, useState } from "react";
import "./style.scss";
import CoinMarketCapIcon from "assets/icons/cmcIcon.svg";
import TwitterIcon from "assets/icons/twitter.svg";
import GlobeIcon from "assets/icons/globe.svg";
import { TVChartContainer } from "components/TVChartContainer";
import {ReactComponent as DeleteIcon} from "assets/icons/close.svg";
import { useSelector } from "react-redux";

const TradingChart = ({marketData, updateMarket}) => {

  const [page, setPage] = useState(0);
  const [favoriteMarkets, setFavoriteMarkets ] = useState([
    {
      base: "SOL",
      quote: "USDC"
    },
    {
      base: "PRISM",
      quote: "USDC"
    },
    {
      base: "ETH",
      quote: "USDC"
    }
  ]);
  const state = useSelector((state) => state.storage);

  useEffect(() => {
    let favMarkets = localStorage.getItem("favoriteMarkets");
    if(favMarkets) {
      setFavoriteMarkets(JSON.parse(favMarkets))
    } else {
      localStorage.setItem("favoriteMarkets", JSON.stringify(favoriteMarkets));
    }
  },[]);

  useEffect(() => {
    if(marketData.pairs) {
      let match = false;
      let SOL_MARKET_OPENED = false;
      for(let i = 0; i < favoriteMarkets.length; i++) {
        if(marketData.pairs.base.symbol.toLowerCase() === favoriteMarkets[i].base.toLowerCase() && marketData.pairs.quote.symbol.toLowerCase() === favoriteMarkets[i].quote.toLowerCase())
          match = true;
        if(favoriteMarkets[i].base.toLowerCase() === "sol" || favoriteMarkets[i].base.toLowerCase() === "wsol")
          SOL_MARKET_OPENED = true;
      }
      if(!match) {
        let arr = Object.assign([], favoriteMarkets);
        if(marketData.pairs.base.symbol.toLowerCase() === "wsol") {
          if(!SOL_MARKET_OPENED)
            arr.push({
              base: "SOL",
              quote: marketData.pairs.quote.symbol
            });
        }
        else
          arr.push({
            base: marketData.pairs.base.symbol,
            quote: marketData.pairs.quote.symbol
          });
        setFavoriteMarkets(arr);
        localStorage.setItem("favoriteMarkets", JSON.stringify(arr));
      }
      
    }
  }, [marketData]);


  function switchMarket(market, page) {
    setPage(page);
    window.history.replaceState(null, market.base + "-" + market.quote + " | Prism Pro", "/?trade="+market.base+"-"+market.quote)
    updateMarket(market)
  }
  function removeFavoriteMarket(index) {
    let arr = Object.assign([], favoriteMarkets);
    arr.splice(index,1);
    setFavoriteMarkets(arr);
    localStorage.setItem("favoriteMarkets", JSON.stringify(arr));
  }

  function doesMarketMatch(item) { // checks if specified market matches current market
    if(marketData && marketData.pairs) {
      if(marketData.pairs.base.symbol.toLowerCase() === "sol" || marketData.pairs.base.symbol.toLowerCase() === "wsol") {
        if(item.base.toLowerCase() === "sol" || item.base.toLowerCase() === "wsol") return true;
      }
      if(marketData.pairs.base.symbol === item.base && marketData.pairs.quote.symbol === item.quote)
        return true;
      return false;
    }
    return false;
  }

  return <div className="tradingChart">
    <div className="chartTopBar disable-select">
      {
        favoriteMarkets.map((item, i) => {
          return <div key={i} className={doesMarketMatch(item) ? "button selected" : "button"}>
            <div className="buttonOverlay" onClick={() => switchMarket(
              item,
              i
            )}/>
            <CryptoIcon symbol={item.base} size={20}/>
            <p>{item.base}-{item.quote}</p>
            <DeleteIcon stroke="var(--gray500)" width={12} height={12} style={{marginLeft:"1rem"}} onClick={() => removeFavoriteMarket(i)}/>
        </div>
        })
      }
    </div>

    <div className="chart">
      {
        marketData.pairs &&
        <TVChartContainer marketData={marketData} currentTheme={state.theme}/>
      }
    </div>

  </div>
}

export default TradingChart;